export const toleranceOptions = [
    { name: "0.1%", value: 0.1 },
    { name: "0.5%", value: 0.5 },
    { name: "1%", value: 1 },
];

export const speedOptions = [
    { name: "Standard (5)", value: 5 },
    { name: "Fast (6)", value: 6 },
    { name: "Instant (7)", value: 7 },
];